import enTranslationMessages from '../translations/compiled/en-US.json';

export const DEFAULT_LOCALE = 'en-US';

export const appLocales = [
  'en',
  'en-US',
  'en-GB',
  'es-ES',
  'af-ZA',
  'am-ET',
  'ar',
  'az-AZ',
  'bg-BG',
  'bn-IN',
  'bs-BA',
  'ca',
  'cs-CZ',
  'da-DK',
  'de-DE',
  'el-GR',
  'es-MX',
  'et-EE',
  'fa-AF',
  'fa-IR',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'gu-IN',
  'ha',
  'he-IL',
  'hi-IN',
  'hr-HR',
  'ht-HT',
  'hu-HU',
  'hy-AM',
  'id-ID',
  'it-IT',
  'ja-JP',
  'ka-GE',
  'kk-KZ',
  'kn-IN',
  'ko-KR',
  'lt-LT',
  'lv-LV',
  'mk-MK',
  'ml-IN',
  'mn-MN',
  'mr-IN',
  'ms-MY',
  'nl-NL',
  'no-NO',
  'or-IN',
  'pa-IN',
  'pl-PL',
  'ps',
  'pt-BR',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'si-LK',
  'sk-SK',
  'sl-SI',
  'so',
  'sq-AL',
  'sr-RS',
  'sv-SE',
  'sw',
  'ta-IN',
  'te-IN',
  'th-TH',
  'tl-PH',
  'tr-TR',
  'uk-UA',
  'ur',
  'uz-UZ',
  'vi-VN',
  'zh-CN',
  'zh-HK',
  'zh-TW',
];

type Messages = Record<string, string>;

export const DEFAULT_MESSAGES: Messages = enTranslationMessages;

// Locales that read another locale's catalog. fr-FR reads fr-CA's.
const CATALOG_ALIASES: Record<string, string> = {
  en: DEFAULT_LOCALE,
  'fr-FR': 'fr-CA',
};

const loaded = new Map<string, Messages>([[DEFAULT_LOCALE, DEFAULT_MESSAGES]]);

const catalogOf = (locale: string) => CATALOG_ALIASES[locale] ?? locale;

/**
 * The compiled catalog for a locale in `appLocales`. Every catalog but English is
 * its own chunk, so a page downloads only the language it shows.
 */
export async function loadMessages(locale: string): Promise<Messages> {
  const catalog = catalogOf(locale);
  const cached = loaded.get(catalog);
  if (cached) {
    return cached;
  }
  const module = await import(`../translations/compiled/${catalog}.json`);
  loaded.set(catalog, module.default);
  return module.default;
}

/** A catalog `loadMessages` already resolved, so a render can use it at once. */
export function loadedMessages(locale: string): Messages | undefined {
  return loaded.get(catalogOf(locale));
}
